(function () {
  var WIDGET_SRC = 'https://dashboard.lyvecom.com/widget/widget.js';
  var scriptPromise = null;

  function ensureWidgetScript() {
    if (typeof LyveComWidget !== 'undefined') {
      return Promise.resolve();
    }
    if (scriptPromise) {
      return scriptPromise;
    }
    scriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + WIDGET_SRC + '"]');
      if (existing) {
        function done() {
          if (typeof LyveComWidget !== 'undefined') resolve();
          else reject(new Error('LyveComWidget missing'));
        }
        if (existing.dataset.lyveLoaded === '1') {
          done();
          return;
        }
        existing.addEventListener('load', function onLoad() {
          existing.removeEventListener('load', onLoad);
          existing.dataset.lyveLoaded = '1';
          done();
        });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = WIDGET_SRC;
      s.async = true;
      s.onload = function () {
        s.dataset.lyveLoaded = '1';
        resolve();
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return scriptPromise;
  }

  function mount(node) {
    if (!node || node.dataset.lyvecomMounted === '1') return;
    var carouselId = node.getAttribute('data-carousel-id');
    if (!carouselId || !node.id) return;
    node.dataset.lyvecomMounted = '1';
    var parentSel = '#' + node.id;
    ensureWidgetScript()
      .then(function () {
        if (typeof LyveComWidget === 'undefined') return;
        LyveComWidget.mountCarouselComponent({
          carouselID: carouselId,
          parentElement: parentSel,
          carousel: true,
          lng: 'en',
        });
      })
      .catch(function () {});
  }

  function scan(container) {
    var root = container && container.querySelectorAll ? container : document;
    var nodes = root.querySelectorAll('[data-see-it-lyvecom]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      ensureWidgetScript().then(function () {
        for (var i = 0; i < nodes.length; i++) {
          mount(nodes[i]);
        }
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, observer) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!e.isIntersecting) continue;
          observer.unobserve(e.target);
          mount(e.target);
        }
      },
      { root: null, rootMargin: '200px 0px 240px 0px', threshold: 0.01 }
    );

    for (var j = 0; j < nodes.length; j++) {
      var n = nodes[j];
      if (n.dataset.lyvecomMounted === '1') continue;
      io.observe(n);
    }
  }

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) {
      scan(ev.target);
    }
  });
})();
